import * as core from '../../../../../../../core'

import { query } from './external-institutions-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.external-institutions.widgets.external-institutions-table',
    description: 'External Institutions',
    name: 'External Institutions',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
